import { render, staticRenderFns } from "./FormAddressBlock.vue?vue&type=template&id=1466e9b4&scoped=true&"
import script from "./FormAddressBlock.vue?vue&type=script&lang=js&"
export * from "./FormAddressBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1466e9b4",
  null
  
)

export default component.exports